import { useEffect, useState } from "react";
import useAccount from "../authorization/useAccount";
import { useNavigate } from "react-router-dom";
import useFirestore from "../common/useFirestore";

function useCheckOut(id){
    const uid = sessionStorage.getItem("uid");
    const navigate = useNavigate();
    const {getCommonUser} = useAccount(uid);
    const {readFirestoreOneDoc} = useFirestore();
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [ready, setReady] = useState(false);
    const [modal, setModal] = useState({
        title:"",
        content:"",
        onConfirmClickHandler:() => {}
    });

    const [amount, setAmount] = useState({
        currency: "KRW",
        value:0,
    })
    const [user, setUser] = useState({
        name:"",
        email:"",
    })
    const [order, setOrder] = useState({
        item:[],
        totalAmount:0
    })
    useEffect(() => {
        getUser();
    }, [])

    useEffect(() => {
        if(user.email){
            getOrder()
        }
    }, [user])

    useEffect(() => {
        if(order.totalAmount){
            setAmount({
                ...amount,
                value:order.totalAmount
            })
        }
    }, [order])

    useEffect(() => {
        if(amount.value && user.email && order.totalAmount){
            setReady(true);
        }
    }, [amount, user, order])

    const getUser = async() => {
        const user = await getCommonUser();
        if(!user){
            setModal({
                title:"ERROR",
                content:"사용자를 찾을 수 없습니다\n다시 로그인 해주세요",
                onConfirmClickHandler:() => navigate("/login")
            })
            setIsOpenModal(true);
            return ;
        }
        setUser({
            name:user.name,
            email:user.id,
        })
    }

    const getOrder = async() => {
        const order = await readFirestoreOneDoc(`Pay/${user.email}/Order`, id).then(res => {
            if(res.exists()){
                return res.data();
            }
            return null;
        })
        if(order){
            if(order.state === "COMPLETE"){
                setModal({
                    title:"INFO",
                    content:"이미 처리된 주문 입니다",
                    onConfirmClickHandler:() => navigate("/profile")
                })
                setIsOpenModal(true);
                return;
            }
            setOrder({
                item:order.item,
                totalAmount:order.total_amount,
            });
        }
    }

    return {user, order, isOpenModal, modal, amount, ready};
}

export default useCheckOut;